import { createCRUDHook } from './createCRUDHook';
import {
  CompletePreAssembledAssemblyDto,
  CompletePreAssembledAssemblyResultDto,
  JsonPatch,
  PreAssembledAssemblyDto,
} from 'utils/models';
import { AxiosResponse } from 'axios';
import {
  TBL_ASSEMBLED_ASSEMBLY_PROCESS,
  GET_PRE_ASSEMBLED_ASSEMBLY_PROCESS,
  COMPLETE_PRE_ASSEMBLED_ASSEMBLY_PROCESS,
} from './apiEndPoints';

interface PreAssembleCustomOperations {
  getPreAssembleData: () => Promise<PreAssembledAssemblyDto[]>;
  addPreAssembleData: (
    param: CompletePreAssembledAssemblyDto
  ) => Promise<CompletePreAssembledAssemblyResultDto>;
  updatePreAssembleData: (
    param: JsonPatch[],
    id: number
  ) => Promise<AxiosResponse>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  PreAssembledAssemblyDto,
  PreAssembledAssemblyDto[],
  PreAssembleCustomOperations
>({
  entityName: 'PreAssemble',
  endpoint: TBL_ASSEMBLED_ASSEMBLY_PROCESS,

  customOperations: (auth) => ({
    getPreAssembleData: async (): Promise<PreAssembledAssemblyDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_ASSEMBLED_ASSEMBLY_PROCESS + GET_PRE_ASSEMBLED_ASSEMBLY_PROCESS
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    addPreAssembleData: async (
      param: CompletePreAssembledAssemblyDto
    ): Promise<CompletePreAssembledAssemblyResultDto> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          TBL_ASSEMBLED_ASSEMBLY_PROCESS +
            COMPLETE_PRE_ASSEMBLED_ASSEMBLY_PROCESS,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    updatePreAssembleData: async (
      param: JsonPatch[],
      id: number
    ): Promise<AxiosResponse> => {
      try {
        const res = await auth.makeAuthenticatedPatch(
          `${TBL_ASSEMBLED_ASSEMBLY_PROCESS}/${id}`,
          param
        );
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const PreAssembleContext = Context;
export const usePreAssembleManager = useManager;
export const usePreAssemble = useConsumer;
